import { keysOf } from './categories';
import { nonGraphableKeys } from './constants';
import { parseTargetConditionValue } from './ogql';
import { IChartData } from './types';

// Get all values excluding those with keys === id || name
export const uniqueDataValues = (data: (IChartData & { prevChange?: {} })[], additionalScaleData: number[]) => {
  const values =
    data && data.length > 0
      ? data.reduce((accumulator, currentValue) => {
          const keys = keysOf(currentValue).filter((key) => !nonGraphableKeys.includes(key));

          return accumulator.concat(keys.map((key) => currentValue[key]));
        }, [])
      : [];

  if (additionalScaleData) {
    return values.concat(additionalScaleData);
  }

  return values;
};

// convert a list of things into "[first thing, last thing]"
export const dataValuesToRange = (values: number[], showAsPercentOfTotal: boolean): number[] => {
  if (showAsPercentOfTotal) {
    return [0, 1];
  } else if (values.length === 1) {
    // when we have a single value we want to adjust the range so the point doesn't land on the axis
    if (values[0] > 0) {
      return [0, values[0] * 2];
    } else if (values[0] === 0) {
      // 10 is arbitrary, just need the 0 to appear in the middle
      return [-10, 10];
    } else {
      return [values[0] * 2, 0];
    }
  }

  return [Math.min(...values), Math.max(...values)];
};

export const targetToAdditionalScaleData = (target) =>
  target && target.conditions.map((c) => parseTargetConditionValue(c.value.text));
